export const NAME_SPACE = 'AssetView';
export const ROOT_STATE_KEY = 'assetview';
export const ROOT_SLICE_KEY = 'DateRangeFilter';
